<template>
  <div class="PLP">
    <header class="PLP__Header">
      <div class="row">
        <div class="col-7 col-sm-7">
          <h2 id="plp_table_name">
            {{ (!isMobile ? $t("profitloss.profitloss") : '') + ' ' + $t("profitloss.portfolio") }}
          </h2>
        </div>

        <div
          class="col-5 col-sm-5 d-flex justify-content-end align-items-center"
        >
          <div class="text-nowrap text-muted font-weight-light">
            <a
              href="/"
              :class="[!showHistory ? '' : 'text-white']"
              @click.prevent="toggleShowHistory(false)"
              >{{ $t("profitloss.current") }}</a
            >
            /
            <a
              href="/"
              :class="[showHistory ? '' : 'text-white']"
              @click.prevent="toggleShowHistory(true)"
              >{{ $t("profitloss.history") }}</a
            >
          </div>
          <router-link
            v-if="!showHistory"
            class="btn btn-primary text-nowrap ml-3 ml-sm-5"
            to="/profitloss/transactions/new/buy"
          >
            <i class="fa fa-plus-circle"></i>
            <span class="d-none d-md-inline hidden-xs-down ml-2">
              {{ $t("profitloss.transaction") }}
            </span>
          </router-link>
        </div>
      </div>
    </header>

    <main>
      <ProfitLossPortfolioTable />
    </main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileMixin from "@/mixins/mobile";
import ProfitLossPortfolioTable from "./ProfitLossPortfolioTable.vue";

export default {
  name: "ProfitLossPortfolio",
  mixins: [MobileMixin],
  components: {
    ProfitLossPortfolioTable,
  },
  computed: {
    ...mapGetters({
      showHistory: "profitloss/showHistory",
    }),
  },
  methods: {
    ...mapActions({
      toggleShowHistory: "profitloss/toggleShowHistory",
    }),
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.PLP {
  margin-top: 120px;

  @include breakpoint-manual(max-width, $break-small - 1px) {
    margin-top: 80px;
  }
}

.PLP__Header {
  border-bottom: 3px solid $color-primary;
  padding: 0 0 8px;
  margin: 0 0 30px;

  h2 {
    margin: 0;

    @include breakpoint-manual(max-width, $break-extra-small - 1px) {
      margin-top: 5px;
    }
  }
}
</style>
